import { __awaiter, __generator } from "tslib";
import { useCallback } from 'react';
import { useUserProfile } from './useUserProfile';
export var useDoesMetricExist = function () {
    var userProfile = useUserProfile();
    return useCallback(function (metricName, exactMatch) { return __awaiter(void 0, void 0, void 0, function () {
        var userProfileMetrics, keys;
        return __generator(this, function (_a) {
            userProfileMetrics = userProfile === null || userProfile === void 0 ? void 0 : userProfile.metrics;
            if (!userProfileMetrics) {
                // $TODO: Validate cases where this is missing on the page
                // when user is new, etc.
                return [2 /*return*/, false];
            }
            keys = Object.keys(userProfileMetrics);
            if (exactMatch) {
                return [2 /*return*/, keys.includes(metricName)];
            }
            // Otherwise, if keys contain the metric name, return true
            return [2 /*return*/, keys.find(function (key) { return key.includes(metricName); }) ? true : false];
        });
    }); }, [userProfile === null || userProfile === void 0 ? void 0 : userProfile.metrics]);
};
//# sourceMappingURL=useDoesMetricExist.js.map